'use client'

import React from 'react'
import { Grid, styled, GridProps } from '@mui/material'

interface PaddedGridProps extends Omit<GridProps, 'children'> {
  children: React.ReactNode
}

const PaddedMuiGrid = styled((props: GridProps) => <Grid {...props} />)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    width: 'calc(99.9% * .83333 - (30px - 30px * .83333))', // Copied from CMS styles
    margin: 'auto'
  }
}))

const PaddedGrid: React.FC<PaddedGridProps> = ({ children, ...rest }) => {
  return <PaddedMuiGrid {...rest}>{children}</PaddedMuiGrid>
}

export default PaddedGrid
